import Lottie from 'lottie-react';
import SessionReset from '@/assets/animation/SessionReset.json';

import LoadingBubbleData from '@/assets/animation/LoadingBubble.json';
import NewSellerBoxLogoCircle from '@/assets/icons/NewSellerBoxLogoCircle.svg?react';
import SellerBoxLogoCircleGradient from '@/assets/icons/SellerBoxLogoCircleGradient.svg?react';

import BulletList from '@/components/molecules/BulletList';
import { cn } from '@/utils/tailwind';

//thinking 추가 : 처음 세션 시작 시, 봇이 생각중인 상태
interface BotBubbleProps {
  type: 'loading' | 'headerBubble' | 'bulletBubble' | 'textBubble' | 'thinking';
  text?: string;
  list?: Array<string>;
  isDashboard?: boolean;
  isGradient?: boolean;
}

const BotBubble = ({ type, text, list, isDashboard, isGradient = false }: BotBubbleProps) => {
  switch (type) {
    case 'thinking':
      return (
        <div className="mb-[10px] flex w-full flex-col gap-[10px] pt-4">
          <Lottie className="mb-[20px] w-[58px]" animationData={SessionReset} loop />
          {/* <div className="text-gr750 text-xs">대화 준비중...</div> */}
        </div>
      );

    case 'loading':
      return (
        <div className="mb-[10px] flex w-full flex-col gap-[10px]">
          <div
            className={cn('flex  gap-[8px]', {
              'items-center': isDashboard,
              'items-end': !isDashboard,
            })}
          >
            <SellerBoxLogoCircleGradient
              width={isDashboard ? 20 : 32}
              height={isDashboard ? 20 : 32}
            />
            <span className="text-gr-900 Body5M14">셀러박스 AI</span>
          </div>
          <Lottie className="mb-[20px] w-[58px]" animationData={LoadingBubbleData} loop />
        </div>
      );

    case 'headerBubble':
      return (
        <div className="flex w-full flex-col gap-[10px]">
          <div
            className={cn('flex  gap-[8px]', {
              'items-center': isDashboard,
              'items-end': !isDashboard,
            })}
          >
            <SellerBoxLogoCircleGradient
              width={isDashboard ? 20 : 32}
              height={isDashboard ? 20 : 32}
            />
            <span className="text-gr-900 Body5M14">셀러박스 AI</span>
          </div>
          <div className=" w-fit max-w-[90%] whitespace-pre-wrap break-words rounded-[12px] bg-gr-50 p-[12px] text-gr-800 Body5M14">
            {text || '일시적으로 오류가 발생하였습니다.\n오류가 반복되면 1:1 문의를 남겨주세요.'}
          </div>
        </div>
      );
    case 'bulletBubble':
      return (
        <div className="w-fit max-w-[90%] whitespace-pre-wrap break-words rounded-[12px] bg-gr-50 p-[12px] text-gr-800 Body5M14">
          <BulletList
            data={[
              `고려 요소 : ${text}`,
              `키워드 : ${list && list.map((item) => `"${item}"`).join(', ')}`,
            ]}
            className="gap-0"
          />
        </div>
      );

    case 'textBubble':
      return (
        <div className="w-fit max-w-[90%] whitespace-pre-wrap break-words rounded-[12px] bg-gr-100 p-[12px] text-gr-800 Body5M14">
          {text}
        </div>
      );
  }
};

export default BotBubble;
